import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const ChecklistsLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/checklists'
            : '/dashboard/building-dashboard/checklists'
        }
      >
        <span>
          {t('navbar:upsellingLinks.checklists')}
          <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

ChecklistsLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default ChecklistsLink
